/* eslint-disable no-unused-vars */
import { cn } from "@aichat/ui/lib/utils";
import { Textarea } from "./textarea";
import { Typography } from "./typography";

type ActionAdditionalFeedbackProps = {
  className?: string;
  wrapperClassName?: string;
  value?: string;
  text?: string;
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
};

export const ActionAdditionalFeedback = ({
  className,
  wrapperClassName,
  disabled,
  value,
  onChange,
  text,
}: ActionAdditionalFeedbackProps) => {
  return (
    <div
      className={cn(
        "py-4 bg-white rounded-lg text-center flex flex-col items-center gap-4",
        wrapperClassName,
      )}
    >
      <Typography
        variant="h5"
        className={cn(
          "underline decoration-dashed decoration-muted-foreground underline-offset-4 whitespace-pre-line",
          className,
        )}
      >
        {text}
      </Typography>
      <Textarea
        placeholder="Tell us about your experience..."
        disabled={disabled}
        value={value}
        className="resize-none"
        onChange={onChange}
      />
    </div>
  );
};
